/* eslint-disable @typescript-eslint/no-explicit-any */

import Highcharts from 'highcharts'
import { useEffect, useId, useState } from 'react'
import ChartSkeleton from '../../skeleton/ChartSkeleton'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../reducers/users'
import BaseChart from '../../charts/BaseChart'

interface IVisualizationsBasicColumnProps {
  categories: any
  series: any
  axisTitle?: string
  tooltipTitle?: string
  long?: boolean
}

const VisualizationsBasicColumn = (props: IVisualizationsBasicColumnProps) => {
  const { categories, series, axisTitle, long } = props
  const [isLoading, setIsLoading] = useState(true)
  const { darkModeEnabled } = useSelector(selectUser)
  const textColor = darkModeEnabled ? '#FFFFFF' : '#1c2024'
  const chartId = useId()

  useEffect(() => {
    if (categories && series) {
      setIsLoading(true)
      const timer = setTimeout(() => setIsLoading(false), 400)
      return () => clearTimeout(timer)
    }
  }, [categories, series])

  const options: Highcharts.Options = {
    chart: {
      type: 'column',
      inverted: true,
      height: `${long ? '1000px' : '500px'}`,
      backgroundColor: 'transparent',
    },
    title: {
      text: undefined,
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      categories,
      labels: {
        style: {
          color: textColor,
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: `${axisTitle ? axisTitle : 'Percent'}`,
        style: {
          color: textColor,
        },
      },
      labels: {
        style: {
          color: textColor,
        },
      },
    },
    tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> <br/>',
      shared: true,
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
        },
      },
    },
    series,
    credits: {
      enabled: false,
    },
  }

  return <>{isLoading ? <ChartSkeleton fullWidth={true} /> : <BaseChart options={options} id={chartId} />}</>
}

export default VisualizationsBasicColumn
